import React from 'react'

import { Modal } from 'antd'

const ValidationUploadConfirmationModal = ({ visible, onConfirm, onCancel, t }) => {
  return (
    <Modal
      title={t('Warning')}
      visible={visible}
      okText={t('Yes')}
      cancelText={t('No')}
      onOk={onConfirm}
      onCancel={onCancel}
      destroyOnClose
    >
      <p>{t('validation_upload_confirmation.message')}</p>
    </Modal>
  )
}

export default ValidationUploadConfirmationModal
